<template>
  <SectionPage :img="img" :content="content" :btn="btn" :hasContinueBtn="hasContinueBtn"/>
</template>

<script>
import SectionPage from '@/layout/SectionPage.vue'
export default {
  name: "Begin",
  components: {
    SectionPage
  },
  data() {
    return {
      img: require('@/assets/section-bg/section0.jpg'),
      content: {
        componentsType: {
          pc: 'shortBtn sectionBtn',
          mobile: 'shortBtn sectionBtn'
        },
        title: 'YOUR JOURNEY TO HEALTH STARTS HERE!',
        boldText: 'Our commitment to your personal privacy is our highest priority. Your health information is protected and secured by Femometer.*',
        text: 'Tell us about yourself. We\'ll get to know you and provide supplements tailored to your unique needs.'
      },
      btn:{
        text: 'Begin',
        link: '/questionnaire/section1',
      },
    }
  },
  computed:{
    hasContinueBtn(){
      return this.$store.state.answerQsNumber? true: false
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
